import {h, Fragment} from "preact"
export default function Checkboxes({ facet, toggleFilter}) {
    // console.log(facet);
    // previous field -> 'customFields.cql-category
    const getCategoryDisplayValue = (value) => {
        if (facet.field === 'extra.facet_transformed_66e205266f051413ad736ec8_cql-category' && value.includes('>')) {
            const categories = value.split('>');
            return categories[categories.length - 1].trim();
        }
        return value;
    };
    
    const getFacetData = () => {
        if (facet.field === 'extra.facet_transformed_66e205266f051413ad736ec8_cql-category') {
            const alteredFacetData = facet.data.map(i => ({
                ...i,
                realValue: i.value.split(">").pop()
            }));

            const sortedFacetData = alteredFacetData.sort((a, b) => a.realValue < b.realValue ? -1 : 1);

            return sortedFacetData;
        }

        return facet.data;
        
    }

    return (
        <ul class="ns-facet__filter-list">
            {getFacetData().map(value => {
                const displayValue = getCategoryDisplayValue(value.value);
                return (
                    <li
                        class={`ns-filter ns-relative ns-flex ns-justify-between ns-items-center ${value.selected ? "ns-checked" : ""}`}
                        data-nosto-element="facet-setting"
                    >
                        <label className="ns-filter__checkbox ns-w-full ns-flex ns-flex-nowrap">
                            {displayValue}
                            <input
                                className="ns-filter__checkbox-input"
                                type="checkbox" 
                                checked={value.selected} 
                                onChange={e => {
                                    e.preventDefault()
                                    toggleFilter(facet.field, value.value, !value.selected)
                                }} 
                            />
                            <span className="ns-filter__checkbox-count">
                                ({value.count})
                            </span>
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}